import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, EventEmitter, Component, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/avatar/avatar';

class FadvAvatarIconDirective {
    constructor() {
        this.slotName = 'icon';
    }
}
FadvAvatarIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvAvatarIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvAvatarIconDirective, selector: "[fadvAvatarIcon]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fadvAvatarIcon]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvAvatarComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        /* Alternative text for the image */
        this.label = '';
        /* The image source to use for the avatar */
        this.image = '';
        /* Initials to use as a fallback when image is available */
        this.initials = '';
        /* The shape of the avatar
          'circle' | 'square' | 'rounded'
        */
        this.shape = 'circle';
        this.size = 'small';
        this.avatarUploaded = new EventEmitter();
    }
    handleAvatarUpload(event) {
        this.avatarUploaded.emit(event.detail.image);
    }
}
FadvAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvAvatarComponent, selector: "fadv-avatar", inputs: { label: "label", image: "image", initials: "initials", shape: "shape", size: "size", upload: "upload", uploadPercentage: "uploadPercentage" }, outputs: { avatarUploaded: "avatarUploaded" }, host: { listeners: { "avatar-upload": "handleAvatarUpload($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "image", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "initials", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "shape", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "size", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "upload", void 0);
__decorate([
    Forward()
], FadvAvatarComponent.prototype, "uploadPercentage", void 0);
__decorate([
    Track()
], FadvAvatarComponent.prototype, "avatarUploaded", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-avatar',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { label: [{
                type: Input
            }], image: [{
                type: Input
            }], initials: [{
                type: Input
            }], shape: [{
                type: Input
            }], size: [{
                type: Input
            }], upload: [{
                type: Input
            }], uploadPercentage: [{
                type: Input
            }], avatarUploaded: [{
                type: Output
            }], handleAvatarUpload: [{
                type: HostListener,
                args: ['avatar-upload', ['$event']]
            }] } });

class FadvAvatarModule {
}
FadvAvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvAvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarModule, declarations: [FadvAvatarComponent, FadvAvatarIconDirective], imports: [FadvCommonModule], exports: [FadvAvatarComponent, FadvAvatarIconDirective] });
FadvAvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvAvatarComponent, FadvAvatarIconDirective],
                    imports: [FadvCommonModule],
                    exports: [FadvAvatarComponent, FadvAvatarIconDirective],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvAvatarComponent, FadvAvatarIconDirective, FadvAvatarModule };
